
import React, { useEffect, useState } from 'react';
import Modal from '../../Dialog/Modal';
import { SolicitationView } from '../../../models/SolicitationView';
import { ExportToCsv } from "export-to-csv-file";
import SolicitationService from '../../../services/SolicitationService/SolicitationService';
import { CSVLink } from 'react-csv';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { PPDropDown } from 'processor-plataform-ui';

interface Props {
    visible: boolean;
    list: any[];
    columns: any[];
    setVisible: Function;
}

const ExportList: React.FC<Props> = (props) => {
    const solicitationService = new SolicitationService(props);
    const [dataRow, setDataRow] = useState<any[]>([]);
    const [fileName, setFileName] = useState<string>('HeyHoChamados');

    const convertData = () => {
        const data = [] as object[];
        var filteredSolicitations = props.list;

        if (!(props.columns.length > 0)) {
            props.columns.push({
                field: 'id',
                headerName: 'N° Sol.',
                hide: false,
                width: "85px",
            } as any);
        }

        for (var x = 0; x < filteredSolicitations.length; x++) {
            try {
                var ToTransformRows: SolicitationView[] = [];
                ToTransformRows = ToTransformRows.concat(retrieveGroupedRows(filteredSolicitations[x]));

                for (var j = 0; j < ToTransformRows.length; j++) {
                    var tickerRow = {} as object;
                    props.columns.map((col: any, iCol: number) => {
                        if (col.field === "statusIcon") {
                            return;
                        }

                        if (col.field === "checkbox") {
                            return;
                        }

                        if (col.hide) {
                            return;
                        }

                        if (iCol >= 0) {
                            try {
                                if (col.renderColumn) {
                                    tickerRow[col.headerName] = col.renderColumn(ToTransformRows[j]);
                                    return;
                                }

                                if (ToTransformRows[j][col.field]) {

                                    if (col.field === "idStatus") {
                                        tickerRow[col.headerName] = solicitationService.statusList[ToTransformRows[j][col.field] - 1].label;
                                        return
                                    }

                                    if (col.field === "registrationDate") {
                                        tickerRow[col.headerName] = moment(ToTransformRows[j][col.field]).format("DD/MM/YYYY HH:mm:ss");
                                        return;
                                    }

                                    tickerRow[col.headerName] = ToTransformRows[j][col.field];
                                }
                            }
                            catch (e) {
                                console.error(e);
                            }
                        }
                    });

                    data.push(tickerRow);
                }
            }
            catch (e) {
                console.error('Problema ao exportar CSV');
            }
        }

        // debugger

        // return data;

        setDataRow(data);

        // console.log(data);

        // try {
        //     const options = {
        //         fieldSeparator: ',',
        //         quoteStrings: '"',
        //         decimalSeparator: '.',
        //         showLabels: true,
        //         showTitle: false,
        //         title: fileName,
        //         useTextFile: false,
        //         useBom: true,
        //         useKeysAsHeaders: true,
        //     };

        //     const csvExporter = new ExportToCsv(options);
        //     csvExporter.generateCsv(data);
        // }
        // catch (e) {
        //     console.error('Problema ao exportar CSV');
        // }

        function retrieveGroupedRows(row: any) {
            var ToTransformRecords: SolicitationView[] = [];

            if ((row instanceof Array)) {
                for (var k = 0; k < (row as unknown as Array<SolicitationView>).length; k++) {
                    ToTransformRecords = ToTransformRecords.concat(retrieveGroupedRows(row[k]));
                }
            }
            else {
                ToTransformRecords.push(row);
            }

            return ToTransformRecords;
        }
    }

    useEffect(() => {
        convertData();
    }, [props.list])

    const exportData = () => {
        if (selectedOption === 1) {
            exportToCSV();
        }
        else {
            exportToXLSX();
        }
    }

    const exportToCSV = () => {
        const csvData: any[] = [];
        // Adicione os cabeçalhos
        csvData.push(Object.keys(dataRow[0]));
        // Adicione os valores
        dataRow.forEach(item => {
            csvData.push(Object.values(item));
        });

        // Codificação UTF-8
        const csvContent = 'data:text/csv;charset=utf-8,\uFEFF' + csvData.map(row => row.join(';')).join('\n');
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', `${fileName}.csv`);
        document.body.appendChild(link);
        link.click();
    };

    const exportToXLSX = () => {
        const ws = XLSX.utils.json_to_sheet(dataRow);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(wb, `${fileName}.xlsx`);
    };

    const [options, setOptions] = useState<any[]>([
        { value: 1, label: "CSV" },
        { value: 2, label: "XLSX" },
    ]);

    const [selectedOption, setSelectedOption] = useState<any>(1);

    return (
        <Modal width={"400px"} visible={props.visible} close={() => props.setVisible(false)} title={"Exportar solicitações"}>
            <div style={{
                display: 'flex',
                justifyContent: 'center'
            }}>
                <PPDropDown
                    openTrigger='click'
                    value={selectedOption}
                    onChange={(e) => setSelectedOption(e.target.value)}
                    options={options}
                    hideFilter
                    width='250px'
                />
            </div>

            <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: "15px"
            }}>
                <button className={"lc-button bg-info"} onClick={() => exportData()}>Exportar</button>
            </div>
        </Modal>
    );
};

export default ExportList;